import { gql } from "@apollo/client";

export const GET_VENUE_COUNT = gql`
  query getVenueCount {
    getVenueCount {
      count
    }
  }
`;
